import { render, staticRenderFns } from "./FeedContentImageWrapper.vue?vue&type=template&id=c43c654a&"
import script from "./FeedContentImageWrapper.vue?vue&type=script&lang=ts&"
export * from "./FeedContentImageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports